import styled from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';
import { media } from '~src/styles/media-templates';

export const InnerCircle = styled.div`
  height: 60px;
  width: 60px;
  margin: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  &hover {
    background-color: rgba(255, 255, 255, 0.25);
  }

  ${media.phone`
    height: 45px;
    width: 45px;
  `}
`;

export const ButtonContainer = styled.div`
  height: 80px;
  margin-left: -10px;
  margin-top: -10px;
  width: 80px;
  position: relative;
  color: white;
  cursor: pointer;
  flex: 0 0 auto;
  & ~ ${InnerCircle} {
    background-color: rgba(255, 255, 255, 0.25);
  }

  ${media.phone`
    height: 65px;
    width: 65px;
  `}
`;

export const CircleContainer = styled.div`
  position: absolute;
  z-index: 10;
`;

export const ArrowContainer = styled(SvgIcon)`
  ${media.phone`
    height: 20px;
    width: 20px;
  `}
`;
